import { NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { NotificationBodyComponent } from './notification-body/notification-body.component';
import { NotificationHostComponent } from './notification-host/notification-host.component';
import { NotificationIconComponent } from './notification-icon/notification-icon.component';
import { NotificationsContainerComponent } from './notifications-container/notifications-container.component';
import { NotificationsController } from './notifications.controller';
import { TextSwapComponent } from './text-swap.component';

@NgModule({
  imports: [RtUICommonModule],
  declarations: [
    NotificationBodyComponent,
    NotificationsContainerComponent,
    NotificationHostComponent,
    TextSwapComponent,
    NotificationIconComponent,
  ],
  exports: [NotificationHostComponent, TextSwapComponent],
})
export class RtUINotificationsModule {}

export {
  NotificationsController,
  NotificationHostComponent,
  NotificationsContainerComponent,
  TextSwapComponent,
};
export { NotificationBodyBase } from './notification-body-base';
export { NotificationHostBase } from './notification-host-base';
export * from './notification-config';
export * from './notification-ref';
export * from './notification-data';
export { NotificationType, FIXED_OVERLAY_LEVEL } from './notifications.controller';
